import tachoEntity from "@/entity/TachoEntity";
import axios from "axios";
import packageInfo from "../../../package.json";

export function compareVersions(v1, v2) {
    const parts1 = v1.split('.').map(Number);
    const parts2 = v2.split('.').map(Number);
    const maxLength = Math.max(parts1.length, parts2.length);

    for (let i = 0; i < maxLength; i++) {
        const num1 = parts1[i] || 0;
        const num2 = parts2[i] || 0;

        if (num1 > num2) return 1;
        if (num1 < num2) return -1;
    }

    return 0;
}

export async function isTachowOutdated() {
    const url = tachoEntity.baseUrl;

    try {
        if (!packageInfo.version) {
            console.warn('Project version is not defined.');
            return false;
        }

        const axiosInstance = axios.create();
        const res = await axiosInstance.get(`${url}manifest/tachow`);

        const latestVersion = _.get(res, 'data.version');
        if (!latestVersion) {
            console.warn('Could not retrieve the latest version.');
            return false;
        }

        if (compareVersions(latestVersion, packageInfo.version) > 0) {
            return true
        }

        console.info(`Tachow is up to date. Latest: ${latestVersion}, Current: ${packageInfo.version}`);
    } catch (e) {
        console.error(e);
    }

    return false;
}
